/**
 * Returns a random integer between 1 and the max (inclusive)
 * @param {Number} max - maximum number. getRandomInt(4) will return 1, 2, 3 or 4
 * @return {Number} the random integer
 */
export function getRandomInt(max) {
	return Math.floor(Math.random() * max) + 1;
}
